/**
 * Ключи намерения товаров: черновик — по базе и цели правки, операция — ещё по
 * действию. Rid нормализуется, регистр цели не важен (D-064).
 */
import { normalizeRid } from '../../../shared/model/scopeKeys'

export { normalizeRid, ownedBy } from '../../../shared/model/scopeKeys'

export const draftKey = (resourceId: string, target: string): string => `${normalizeRid(resourceId)}|${target.toLowerCase()}`

export const operationKey = (resourceId: string, target: string, action: string, detail?: string): string =>
  detail === undefined
    ? `${normalizeRid(resourceId)}|${target.toLowerCase()}|${action}`
    : `${normalizeRid(resourceId)}|${target.toLowerCase()}|${action}|${detail}`
